<template>
  <v-container
    v-show="featuredPatches.length !== 0"
    fluid
    class="featured-patches">
    <div class="featured-patches__header">
      <h2>Featured Patches</h2>
    </div>

    <!-- No Data -->
    <div
      v-if="!featuredPatches || featuredPatches.length===0"
      class="no-data">
      <h3 class="no-data__text">There are no featured patches at this time</h3>
    </div>

    <v-scroll-y-transition
      group
      mode="out-in"
      class="patch-catalog">
      <router-link
        v-for="patch in featuredPatches"
        :key="patch.imageId"
        v-ripple
        class="patch-listing"
        :to="{
          name: 'patch-product',
          params: {
            patchGroup: 'catalog',
            id: patch.imageId,
          },
        }">
        <v-img
          :src="imageDir + patch.imageId + '.png'"
          class="patch-listing__image">
          <div
            slot="placeholder"
            class="patch-listing__placeholder">
            <v-progress-circular
              indeterminate
              color="primary" />
          </div>
        </v-img>
      </router-link>
    </v-scroll-y-transition>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FeaturedPatches',
  data() {
    return {
      //
    };
  },
  computed: {
    ...mapState('patches', {
      imageDir: 'imageDir',
      loading: 'loading',
      errorMessage: 'errorMessage',
    }),
    featuredPatches() {
      return this.$store.state.patches.patches.featured;
    },
  },
  created() {
    this.$store.dispatch('patches/getAllPatches', 'featured');
  },
  methods: {
    //
  },
};
</script>


<style lang="stylus" scoped>
@require('../../stylus/base')

.featured-patches
  &__header
    display: flex
    align-items: center
    justify-content: center
    padding: $base-padding*2
    text-align: center

.no-data
  display: flex
  align-items: center
  justify-content: center
  &__text
    padding: $base-padding*2
    font-size: 1.25rem
    text-align: center
    line-height: normal
    color: $accent
    border: 1px solid $accent
    border-radius: $base-border-radius

.patch-catalog
  display: flex
  flex-flow: row wrap
  align-items: flex-start
  justify-content: flex-start
  @media screen and (max-width: 48rem)
    margin-right: $base-padding * -1
    margin-left: $base-padding * -1

.patch-listing
  position: relative
  flex-basis: 50%
  flex-shrink: 1
  @media screen and (min-width: 36rem)
    flex-basis: (100%/3)
  @media screen and (min-width: 48rem)
    flex-basis: 25%
  @media screen and (min-width: 60rem)
    flex-basis: (100%/6)
  &::before
    content: ''
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    z-index: 1
    background-color: $white
    opacity: 0
    transition: $base-transition
    cursor: pointer
  &:hover::before
    opacity: .24

  &__image
    width: 100%

  &__placeholder
    display: flex
    align-items: center
    justify-content: center
    height: 100%
    width: 100%

</style>
